<div
    class="mat-elevation-z1 custom-mat-table-container"
    tabindex="0"
    [ngStyle]="setContainerStyle()"
>
    <div class="data-status-styles" *ngIf="!hasTableData && isDataReady">
        <no-data-screen [noDataType]="noDataType"> </no-data-screen>
    </div>
    <div class="data-status-styles" *ngIf="(!isDataReady && !hasTableData) || isSearching">
        <spin-loader [type]="'spinner-solid'"></spin-loader>
    </div>
    <table
        mat-table
        [dataSource]="dataSource"
        class="custom-mat-table"
        matSort
        (matSortChange)="sortChange($event)"
        (contentChanged)="matContentChanged()"
    >
        <ng-container matColumnDef="{{ cellInfo.fieldId }}" *ngFor="let cellInfo of headersInfo">
            <th
                id="custom-mat-header-th-{{ cellInfo.fieldId }}"
                mat-header-cell
                mat-sort-header="{{ cellInfo.fieldId }}"
                [ngStyle]="setHeaderStyle(cellInfo)"
                [disabled]="!cellInfo.isSortable"
                *matHeaderCellDef
            >
                @if(cellInfo.dataType === 'icon' && cellInfo.iconProperties?.showIconOnHeader) {
                <i
                    class="{{ cellInfo.iconProperties?.headerIconClass }}"
                    (click)="headerIconClick(cellInfo)"
                ></i>
                } @else if (cellInfo.dataType === 'input' && cellInfo.showInputOnHeader) { } @else {
                {{ cellInfo.fieldName }}
                }
            </th>
            <td
                mat-cell
                [ngStyle]="setCellStyle(element, cellInfo)"
                *matCellDef="let element"
                (click)="cellClickHandler(element, cellInfo)"
                title="{{ element[cellInfo.tooltipProperties?.key] ?? '' }}"
            >
                <div *ngIf="isConventionalDataType(cellInfo)">
                    {{ formatData(element, cellInfo) }}
                </div>
                <div
                    *ngIf="cellInfo.dataType === 'icon'"
                    title="{{ element[cellInfo.iconProperties?.descriptionKey ?? ''] }}"
                >
                    <button
                        mat-icon-button
                        [disabled]="getIconButtonDisableStatus(element, cellInfo)"
                        (click)="iconClickHandler(element, cellInfo)"
                    >
                        <i
                            class="{{ getIcon(element, cellInfo) }}"
                            aria-hidden="true"
                            [ngStyle]="getIconStyle(element, cellInfo)"
                        ></i>
                    </button>
                </div>
                <div
                    *ngIf="cellInfo.dataType === 'chart' && cellInfo.chartProperties"
                    id="{{ cellInfo.fieldId + element[cellInfo?.chartProperties?.chartToFieldId] }}"
                ></div>
                <div *ngIf="cellInfo.dataType === 'input' && cellInfo.dataInputProperties">
                    @switch (cellInfo.dataInputProperties.dataInputType) { @case ('dropdown') {
                    <select
                        [(ngModel)]="element[cellInfo.dataInputProperties.key]"
                        class="mat-custom-table-ddl-area select-light-border-38"
                        [ngStyle]="getDdlStyle(element, cellInfo)"
                        (ngModelChange)="dropdownChanged($event, element, cellInfo)"
                    >
                        <option
                            *ngFor="let ddlItem of element['itemList']"
                            [value]="ddlItem[cellInfo.dataInputProperties.key]"
                        >
                            {{ ddlItem[cellInfo.dataInputProperties.valueKey] }}
                        </option>
                    </select>
                    } @case ('checkbox') {
                    <p-checkbox
                        [(ngModel)]="element[cellInfo.dataInputProperties.key]"
                        [binary]="true"
                        [disabled]="element[cellInfo.dataInputProperties.disableKey]"
                        (change)="
                            inputChangeHandler(
                                element[cellInfo.dataInputProperties.key],
                                element,
                                cellInfo
                            )
                        "
                        title="{{ element[cellInfo.dataInputProperties.descriptionKey] }}"
                    />
                    } @case ('textInput') {
                    <span
                        style="color: #ff1e00"
                        *ngIf="element[cellInfo.dataInputProperties?.errorKey]?.length > 0"
                    >
                        <p>{{ element[cellInfo.dataInputProperties?.errorKey] }}</p>
                    </span>
                    <div class="custom-mat-table-text-input">
                        <input
                            matInput
                            class="custom-table-cell-input"
                            [(ngModel)]="element[cellInfo.dataInputProperties.key]"
                            (change)="
                                inputChangeHandler(
                                    element[cellInfo.dataInputProperties.key],
                                    element,
                                    cellInfo
                                )
                            "
                            [disabled]="element[cellInfo.dataInputProperties.disableKey]"
                            [type]="cellInfo.dataInputProperties.textInputType"
                        />
                    </div>
                    } @case ('radio') { } @default { } }
                </div>
            </td>
            <td
                [ngStyle]="setFooterStyle(cellInfo)"
                mat-footer-cell
                *matFooterCellDef
                title="{{ getAggregation(cellInfo) }}"
            >
                {{ getAggregation(cellInfo) }}
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        <ng-container *ngIf="customTableInfo.showSummary">
            <tr
                mat-footer-row
                *matFooterRowDef="displayedColumns; sticky: true"
                [hidden]="!hasTableData"
            ></tr>
        </ng-container>
    </table>
</div>
<mat-paginator
    #paginator
    class="mat-elevation-z2 mat-custom-table-paginator"
    (page)="handlePageEvent($event)"
    [disabled]="paginationDisabled"
    [showFirstLastButtons]="showFirstLastButtons"
    [pageSizeOptions]="pageSizeOptions"
    [length]="paginationLength"
    [pageSize]="pageSize"
    aria-label="Select page"
    *ngIf="showPaginator"
>
</mat-paginator>
